import * as React from "react";
const SvgPausa = (props) => (
  <svg
    {...props}
    id="pausa_svg__Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="1rem"
    height="1rem"
    role="img"
  >
    <defs>
      <style>
        {
          ".pausa_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"
        }
      </style>
    </defs>
    <path className="pausa_svg__cls-1" d="M6.52 3.45v13.1M13.48 3.45v13.1" />
  </svg>
);
export default SvgPausa;
